/**
 * Module dependencies.
 */

import { FormList } from 'app/components/organisms/crud/form-types';
import { requiredRule } from 'app/core/utils/field-rules';
import { usePaginatedCrudRequest } from 'app/hooks/app-requests/crud/use-paginated-crud-request';
import { Drug } from 'app/types/drug';
import { TFunction } from 'react-i18next';

/**
 * Left.
 */

const left = (translate: TFunction): FormList => [
  {
    type: 'inputField',
    name: 'cci',
    label: translate('common.labels.cci'),
    rules: requiredRule(translate)
  },
  {
    type: 'selectField',
    name: 'drugId',
    showSearch: true,
    allowClear: true,
    rules: undefined,
    label: translate('users.sales.add.labels.product'),
    paginated: {
      enabled: true,
      pageSize: 50
    },
    options: {
      hook: usePaginatedCrudRequest as any,
      hookProps: (_values: any, _params: any, options: any) => {
        const searchValue = options?.searchValue?.trim();

        return [
          {
            key: ['drugs-paginated', searchValue || ''],
            endpoint: 'drugs' as any,
            options: {
              ...(searchValue ? { search: searchValue } : {})
            },
            pageSize: 50
          }
        ];
      },
      normalize: (items: Drug[]) => {
        if (!items || !Array.isArray(items)) {
          return [];
        }

        return items
          .filter(item => item && item.id)
          .map(item => ({
            value: item.id,
            registry: item.registry,
            label: JSON.parse(item.name).pt,
            searchValue: JSON.parse(item.name).pt
          }));
      }
    }
  }
];

/**
 * Right.
 */

const right = (translate: TFunction): FormList => [
  {
    type: 'inputField',
    name: 'id',
    disabled: true,
    label: translate('common.labels.id'),
    rules: undefined
  },
  {
    type: 'inputField',
    name: 'createdAt',
    disabled: true,
    label: translate('common.labels.createdAt'),
    rules: undefined
  },
  {
    type: 'inputField',
    name: 'updatedAt',
    disabled: true,
    label: translate('common.labels.updatedAt'),
    rules: undefined
  }
];

/**
 * Export `formFields`.
 */

export const formFields = (translate: TFunction): FormList => [
  {
    type: 'columns',
    gutter: 40,
    name: 'mainWire',
    columns: [
      {
        column: 12,
        children: left(translate)
      },
      {
        column: 12,
        children: right(translate)
      }
    ]
  }
];
